export default "__VITE_ASSET__e9393e45__"